import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-login',
  providers: [MessageService],
  templateUrl: './login-collaborator.component.html',
  styleUrls: ['./login-collaborator.component.scss'],
})
export class LoginCollaboratorComponent {
  loginForm: FormGroup;
  errorMessage: string | null = null;
  isLoading$: Observable<boolean>;
  isSubmitting = false;
  hidePassword = true;
  
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.isLoading$ = this.authService.isLoading$;
    this.loginForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      rolType: ['COLLABORATOR', Validators.required],
    });
  }

  onLogin() {
    if (this.loginForm.valid) {
      this.isSubmitting = true;
      const { email, password, rolType } = this.loginForm.value;

      this.authService.login(email, password, rolType).subscribe({
        next: (response) => {
          if (response) {
            this.router.navigate(['/dashboard/home']); // Cambia a la ruta correspondiente
          } else {
            this.isSubmitting = false;
          }
        },
        error: (error) => {
          this.errorMessage = error.error.message;
          this.isSubmitting = false;
        },
      });
    } else {
      this.isSubmitting = false;
      this.errorMessage = 'Por favor, complete todos los campos.';
    }
  }
}
